// Cookie utility functions for authentication persistence

const isSecure = () => {
  try {
    return typeof window !== 'undefined' && window.location.protocol === 'https:';
  } catch {
    return false;
  }
};

const COOKIE_OPTIONS = {
  path: '/',
  sameSite: 'Lax'
};

// Set a cookie with expiry
export const setCookie = (name, value, days = 365) => {
  try {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);

    const cookieValue = encodeURIComponent(value);
    const cookieString = `${name}=${cookieValue}; expires=${expires.toUTCString()}; path=${COOKIE_OPTIONS.path}; SameSite=${COOKIE_OPTIONS.sameSite}${isSecure() ? '; Secure' : ''}`;

    document.cookie = cookieString;
  } catch (e) {
    console.error('Error setting cookie:', e);
  }
};

// Get a cookie value by name
export const getCookie = (name) => {
  try {
    const nameEQ = name + '=';
    const cookies = document.cookie.split(';');

    for (let cookie of cookies) {
      cookie = cookie.trim();
      if (cookie.indexOf(nameEQ) === 0) {
        const value = decodeURIComponent(cookie.substring(nameEQ.length));
        return value || null; // Return null for empty strings
      }
    }
  } catch (e) {
    console.error('Error reading cookie:', e);
  }
  return null;
};

// Remove a cookie
export const removeCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${COOKIE_OPTIONS.path}`;
};

// Auth-specific cookie functions
export const AUTH_COOKIE_KEYS = {
  ACCESS_TOKEN: 'auth_accessToken',
  REFRESH_TOKEN: 'auth_refreshToken',
  USER: 'auth_user'
};

export const saveAuthToCookies = (data) => {
  setCookie(AUTH_COOKIE_KEYS.ACCESS_TOKEN, data.accessToken, 1); // 1 day for access token
  setCookie(AUTH_COOKIE_KEYS.REFRESH_TOKEN, data.refreshToken, 365); // 365 days for refresh token
  setCookie(AUTH_COOKIE_KEYS.USER, JSON.stringify({
    email: data.email,
    isEmailVerified: data.isEmailVerified,
    preferredLanguage: data.preferredLanguage
  }), 365);
};

export const getAuthFromCookies = () => {
  const accessToken = getCookie(AUTH_COOKIE_KEYS.ACCESS_TOKEN);
  const refreshToken = getCookie(AUTH_COOKIE_KEYS.REFRESH_TOKEN);
  const userStr = getCookie(AUTH_COOKIE_KEYS.USER);

  let user = null;
  if (userStr) {
    try {
      user = JSON.parse(userStr);
    } catch {
      // Invalid JSON, ignore
    }
  }

  return { accessToken, refreshToken, user };
};

export const clearAuthCookies = () => {
  removeCookie(AUTH_COOKIE_KEYS.ACCESS_TOKEN);
  removeCookie(AUTH_COOKIE_KEYS.REFRESH_TOKEN);
  removeCookie(AUTH_COOKIE_KEYS.USER);
};
